import { Button, Dialog, Grid, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect } from 'react';
import { PageHeader } from '../../components/PageHeader';
import { LIGHT_GREY } from '../../const/constants';
import { useFilter } from '../../hooks/useFilter';
import { useResponsiveSpace } from '../../hooks/useResponsiveSpace';
import { Averages } from './components/Averages';
import { Overview } from './components/Overview';
import { SalesSummary } from './components/SalesSummary';
import { TopTenProducts } from './components/TopTenProducts';

export function Dashboard() {
	const filter = useFilter();
	const [opened, { toggle, close }] = useDisclosure(false);

	useEffect(() => {
		if (filter.isEndBeforeStart && !opened) {
			toggle();
		}
	}, [filter.value]);

	const responsiveHeight = useResponsiveSpace([
		[753, '18vh'],
		[1048, '27vh'],
	]);

	useEffect(() => {
		document.body.style.backgroundColor = LIGHT_GREY;
	}, []);

	return (
		<>
			<PageHeader
				title={'Sales Dashboard'}
				filter={filter}
				filterOnSameLine
				variant={'borderless-filled'}
			/>
			<Stack w={'100%'}>
				<Overview filter={filter.value} />
				<SalesSummary filter={filter.value} h={responsiveHeight} p={20} />
				<Grid>
					<Grid.Col span={8}>
						<Averages filter={filter.value} h={responsiveHeight}  />
					</Grid.Col>
					<Grid.Col span={4}>
						<TopTenProducts filter={filter.value} h={responsiveHeight} />
					</Grid.Col>
				</Grid>
			</Stack>

			<Dialog opened={opened} onClose={close} size={'lg'} radius={'md'}>
				<Text mb={'xs'} fw={500}>
					Invalid filter!
				</Text>
				<Text mb={'xs'}>
					Please make sure your selected end date is after your start date.
				</Text>
				<Group justify={'end'}>
					<Button onClick={close}>Ok</Button>
				</Group>
			</Dialog>
		</>
	);
}
